import { render, staticRenderFns } from "./AnualFiscal.vue?vue&type=template&id=1487192d&scoped=true"
import script from "./AnualFiscal.vue?vue&type=script&lang=js"
export * from "./AnualFiscal.vue?vue&type=script&lang=js"
import style0 from "./AnualFiscal.vue?vue&type=style&index=0&id=1487192d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487192d",
  null
  
)

export default component.exports